export function applyConsultantWorklistFilters(consultantId: string): void {
  if (!consultantId) return;

  try {
    localStorage.setItem(
      "alqemiFilters",
      JSON.stringify([{ field: "currentCandidate", value: consultantId }]),
    );
    localStorage.setItem("alqemiOffersFilter", consultantId);
    localStorage.setItem(
      "offersSorting",
      JSON.stringify({ param: "matches.score", order: "desc" }),
    );
    localStorage.setItem(
      "alqemiOffersActiveFilters",
      JSON.stringify({
        status: { type: "select", value: "consultant_review" },
      }),
    );
    localStorage.setItem("alqemiOffersPage", "1");
  } catch (e) {
    console.warn("applyConsultantWorklistFilters: localStorage write failed", e);
  }
}
